import { getAvatarBackColor, getPersonInitials } from "helpers/randomHelpers";
import React, { useRef } from "react";
import { AVATAR_CDN } from "../../../constants/constants";

const Avatar = ({ avatar_key = null, given_name = "", family_name = "" }) => {
  const ref = useRef();
  return (
    <div
      className={`text-white h-100 w-100`}
      style={{ backgroundColor: getAvatarBackColor(given_name) }}
    >
      {avatar_key && (
        <img
          ref={ref}
          className="image-fill"
          src={AVATAR_CDN + avatar_key}
          alt=" "
          onError={() => (ref.current.style.display = "none")}
        />
      )}
      <div>{getPersonInitials(given_name, family_name)}</div>
    </div>
  );
};

export default Avatar;
